"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var createMuiTheme_1 = __importDefault(require("@material-ui/core/styles/createMuiTheme"));
var createOverrides_1 = require("./createOverrides");
var createPalette_1 = require("./createPalette");
var createProps_1 = require("./createProps");
var createSpacing_1 = require("./createSpacing");
var createTypography_1 = require("./createTypography");
exports.createEpicTheme = function (_a) {
    if (_a === void 0) { _a = {}; }
    var overrides = _a.overrides, options = __rest(_a, ["overrides"]);
    var palette = createPalette_1.createPalette(options.palette);
    var typography = createTypography_1.createTypography(typeof options.typography === "function"
        ? options.typography(palette)
        : options.typography);
    var theme = createMuiTheme_1.default(__assign(__assign({}, options), { palette: palette,
        typography: typography, spacing: createSpacing_1.createSpacing(options.spacing), props: createProps_1.createProps(options.props) }));
    theme.overrides = createOverrides_1.createOverrides(theme, overrides);
    return theme;
};
//# sourceMappingURL=createEpicTheme.js.map